<template>
  <el-dialog custom-class="max-dialog1256" title="折扣商品" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :modal="true" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span>基本信息</span>
          </template>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="标题" :label-width="formLabelWidth" prop="title">
                <el-input v-model="form.title" auto-complete="off" :controls="false"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="couponrule.type=='50'">
            <el-col :span="7">
              <el-form-item label="品牌" :label-width="formLabelWidth">
                <CommonTree ref="treeCategory" :defineDataSource="true" @bindData="bindDataCategory"
                            :isShowCheckBox="false"
                            :treeHeight="200" :searchText="couponrule.categoryname"
                            :expandonclicknode="true" :onlyShowGroupType="true"
                            @check="checkCategory"></CommonTree>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="couponrule.type=='50'">
          <el-col :span="7">
            <el-form-item label="客户类型" :label-width="formLabelWidth">
              <el-select v-model="form.pricelevel" placeholder="请选择" :clearable="true">
                <el-option
                  v-for="item in parameterData"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2" v-if="couponrule.type=='50'||couponrule.type=='60'">
          <template slot="title">
           <span class="titlecolor">折扣明细
        <span style="margin-right: 10px;float: right" @click.stop.prevent="showGoodDetailSel()"
              v-if="couponrule.type=='60'">添加商品</span>
        </span>
          </template>
          <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                 v-if="couponrule.type=='60'"
                 class="query-table">
            <tr>
              <td style="background-color: #F4F4F4;text-align: center;" class="center">货品</td>
              <td style="width: 160px;background-color: #F4F4F4;  text-align: center;" class="center">货品编码</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">标准价</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">优惠方式</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">优惠数值</td>
              <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">实际售价</td>
              <td style="width: 60px;background-color: #F4F4F4;  text-align: center;" class="center">操作</td>
            </tr>
            <tr v-for="(item,index) in formp">
              <td class="content">
                {{item.seedname}}
              </td>
              <td class="content">
                {{item.seedcode}}
              </td>
              <td class="content" style="text-align: right">
                {{item.costprice|numeric(2)}}
              </td>
              <td class="content">
                <el-select v-model="item.dismethod" placeholder="折扣" @change="cleatItemValue(item)">
                  <el-option label="折扣" value="0"></el-option>
                  <el-option label="固定价" value="1"></el-option>
                  <el-option label="浮动价" value="2"></el-option>
                </el-select>
              </td>
              <td class="content">
                <el-input v-model="item.discount" size="small" placeholder="输入折扣率"
                          v-if="item.dismethod=='0'"></el-input>
                <el-input v-model="item.fixmoney" size="small" placeholder="输入单价" v-if="item.dismethod=='1'"></el-input>
                <el-input v-model="item.fixmoney" size="small" placeholder="输入浮动额"
                          v-if="item.dismethod=='2'"></el-input>
              </td>
              <td class="content" style="text-align: right">
                <span v-if="item.dismethod=='0'">{{(item.costprice*item.discount*0.1)|numeric(2)}}</span>
                <span v-if="item.dismethod=='1'">{{(item.fixmoney)|numeric(2)}}</span>
                <span v-if="item.dismethod=='2'">{{(parseFloat(item.costprice||0)+parseFloat(item.fixmoney||0))|numeric(2)}}</span>
              </td>
              <td class="center content">
                <el-button @click="deletequery(index, item)" type="text"
                           size="small">删除
                </el-button>
              </td>
            </tr>
          </table>

          <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                 v-if="couponrule.type=='50'"
                 class="query-table">
            <tr>
              <td style="width:150px;background-color: #F4F4F4;text-align: center;" class="center">下单方式</td>
              <td style="width: 80px;background-color: #F4F4F4;  text-align: center;" class="center">折扣</td>
            </tr>
            <tr v-for="(item,index) in filltemplate">
              <td class="content">
                {{item.name}}
              </td>
              <td class="content">
                <el-input v-model="item.discount" placeholder="请输入折扣" v-on:blur="inputFunc(item)"></el-input>
              </td>
            </tr>
          </table>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">确 定</el-button>
    </div>
    <JxcgooddetailSel ref="JxcgooddetailSel" :isShowCheckBox="true"
                      @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <JxcgoodscategorySel ref="JxcgoodscategorySel" :isShowCheckBox="true"
                         @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
  </el-dialog>
</template>


<script>
  import {saveData, getDetail, getControlData, getCouponWay, getCouponRule} from '@/api/set/salefavour';

  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import JxcgoodscategorySel from '../../set/jxcgoodscategory/JxcgoodscategorySel'
  import {independentDept} from '@/api/set/dept';
  import {getGoodsDetail} from '@/api/set/jxcgoodscategory';
  import {list4PriceSet} from '@/api/set/jxcgooddetail';
  import JxcgooddetailSel from '../../set/jxcgooddetail/JxcgooddetailSel'
  import {getParameterDetail} from '@/api/set/parameter';

  export default {
    name: "DataContactEdit",
    data() {

      return {
        loading: false,//防止多次提交
        tableData: [],
        tableDataSkim: [],//特价商品
        formp: [],
        dialogFormVisible: false,
        activeNames: ['1', '2'],
        dazhevisible: false,
        manjianvisible: false,
        processVisible: false,
        distributionVisible: false,
        customername: '',
        isSkim: 0,//1表示特价商品
        excludespecial: true,
        cashTeJia:[],
        parameterData: [],
        couponrule: {
          type: '',
          full: '',
          minus: '',
          discount: '',
          saleprice: '',
          money: '',
          maxbuycount: '',
          categorycode: "",
          categoryname: "",
          filltemplate: {},
          excludespecial: false,
        },
        wayFlag: true,
        filltemplate: [  {name: "现片", value: '10', discount: ""},
          {name: "定制片",value: '20',discount: ""},
          {name: "区分左右眼", value: '30', discount: ""},
          {name: "镜架", value: '80', discount: ""},
          {name: "数量选择", value: '40', discount: ""},
          {name: "加工",value: '50',discount: ""},
          {name: "特殊加工", value: '60', discount: ""}],
        form: {
          unitguid: "",
          begindate: "",
          enddate: "",
          customerserial: "",
          customername: "",
          independentserial: '',
          pricelevel: '',
          salefavouedetail: "",
          province: "",
          city: "",
          county: "",
          couponway: '',
          couponrule: "",
          duration: "",
          couponnum: "",
          title: "",
          describe: ""
        },
        formLabelWidth: '120px',
        rules: {
          title: [
            {required: true, message: '标题必填', trigger: 'blur'},
          ],
        },
      }
    },
    props: {
      forExternalDept: {
        defalut: false//设置客户的时候启用
      }
    },
    methods: {
      //输入框校验，只能输入小数和数字
      inputFunc(item) {
        if (item.discount && "" != item.discount.replace(/^\d+$|^\d*\.\d+$/g, '')) {
          this.$message({
            message: '请输入正确的数字',
            type: 'error'
          })
          item.discount = ''
        }
      },
      goodsDiscount(type) {
        if (this.cashTeJia) {
          for (let i in this.cashTeJia) {
            if (JSON.parse(this.cashTeJia[i].couponrule).type == type) {
              this.$parent.$refs.SaleFavourEditChild.initData(this.cashTeJia[i].unitguid)
            }
          }
        }
        this.$parent.$refs.SaleFavourEditChild.show(type, this.form.unitguid);
      },
      cleatItemValue(item) {
        item.discount = '';
        item.fixmoney = '';
      },
      changeDiscrip(val) {
        this.form.describe = val
      },
      getCustomPrice() {
        if (this.form.customerserial == '' || !'60' == this.couponrule.type.toString() || this.formp.length == 0)
          return;
        var seedcodelist = '';
        for (var i = 0; i < this.formp.length; i++) {
          seedcodelist += this.formp[i].seedcode + ';';
          if (!this.formp[i].dismethod)
            this.formp[i].dismethod = '0';
          else
            this.formp[i].dismethod = this.formp[i].dismethod.toString();
        }
        list4PriceSet({customguid: this.form.customerserial, seedcodelist: seedcodelist}).then(response => {
          var items = response.data.obj;
          for (var i = 0; i < items.length; i++) {

            for (var j = 0; j < this.formp.length; j++) {
              if (this.formp[j].seedcode == items[i].seedcode) {
                if (items[i].prices.length > 0)
                  this.formp[j].costprice = items[i].prices[0].costprice;
                else
                  this.formp[j].costprice = 0;
              }
            }
          }
        })
      },
      //删除明细
      handleDelete(index, row) {
        //如果删除的是类别，则要判断此类别下面是否有特价商品，如果有，则必须先删除特价商品才能删除此类别
        if (!row.seedcode) {
          for (let i in this.tableDataSkim) {
            if (this.tableDataSkim[i].categorycode.startsWith(row.categorycode)) {
              this.$message({
                message: "该类别下存在特价商品，无法删除该类别",
                type: 'warning',
                duration: 1500
              })
              return
            }
          }
        }
        this.tableData.splice(index, 1)
      },
      //删除特价商品
      handleDeleteSkim(index, row) {
        this.tableDataSkim.splice(index, 1)
      },
      //选择商品类别
      showGoodCategorySel(arr) {
        this.$refs.JxcgoodscategorySel.show()
      },
      //显示商品选择页面
      showGoodDetailSel(isSkim) {
        this.isSkim = isSkim
        this.$refs.JxcgooddetailSel.show()
      },

      //选择按商品折扣执行
      afterSelectCodeByGoods(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          var exists = false;
          for (let j in this.formp) {
            //判读该商品是否已经存在
            if (this.formp[j].seedcode == arr[i].seedcode) {
              exists = true;
              break;
            }
          }
          if (!exists) {
            this.formp.push({
              categorycode: arr[i].categorycode,
              categoryname: arr[i].categoryname,
              costprice: null,
              discount: null,
              dismethod: '0',
              fixmoney: null,
              isskim: null,
              parentguid: null,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              tenantid: null,
              unitguid: null
            });
          }
        }
        this.getCustomPrice();
      },

      //选择特价商品之后执行
      afterSelectSkim(arr) {
        let count = 0;
        let i = this.tableDataSkim.length
        label1:
          for (let i in arr) {
            let biaoji = 0
            for (let j in this.tableDataSkim) {
              //判读该特价商品是否已经添加
              if (this.tableDataSkim[j].seedcode == arr[i].seedcode) {
                biaoji = 1
                count++
                continue label1
              }
            }

            if (biaoji == 0) {
              //判断该特价商品不能是合同明细中的商品
              for (let g in this.tableData) {
                if (this.tableData[g].seedcode && arr[i].seedcode == this.tableData[g].seedcode) {
                  biaoji = 1
                  count++
                  continue label1
                }
              }
            }

            if (biaoji == 0) {
              let temp = 0
              for (let g in this.tableData) {
                //判读特价的商品必须属于合同明细下的类别
                if (!this.tableData[g].seedcode && arr[i].categorycode.startsWith(this.tableData[g].categorycode)) {
                  temp = 1
                  this.tableDataSkim.push({
                    isskim: 1,
                    categoryname: arr[i].lname,
                    seedcode: arr[i].seedcode,
                    seedname: arr[i].seedname,
                    categorycode: arr[i].categorycode
                  })
                  break
                }
              }
              if (temp == 0) {
                count++
              }
            }
          }
        if (count > 0) {
          this.$message({
            message: "该特价商品已存在，或者合同明细中已存在，或者不属于合同明细类别下的商品",
            type: 'info'
          })
        }
      },

      //选择商品之后执行
      afterSelectCode(arr) {
        if (this.couponrule.type == '60') {//按商品折扣
          this.afterSelectCodeByGoods(arr)
          return
        }

        if (this.isSkim == 1) {
          this.afterSelectSkim(arr)
          return
        }

        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if ((!this.tableData[j].seedcode && arr[i].categorycode.startsWith(this.tableData[j].categorycode)) || (this.tableData[j].seedcode && this.tableData[j].seedcode == arr[i].seedcode
            )) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              categoryname: arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: arr[i].categorycode
            })
          }
        }
        if (count > 0) {
          this.$message({
            message: "商品已存在，或者属于已选择类别下的商品",
            type: 'info'
          })
        }

      },
      afterSelectCategoryCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            if ((!this.tableData[j].seedcode && (arr[i].categorycode.startsWith(this.tableData[j].categorycode) || this.tableData[j].categorycode.startsWith(arr[i].categorycode)) && arr[i].categorycode != this.tableData[j].categorycode) || (this.tableData[j].seedcode && this.tableData[j].categorycode.startsWith(arr[i].categorycode))) {
              biaoji = 1
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({categorycode: arr[i].categorycode, categoryname: arr[i].categoryname})
          }
        }
        if (count > 0) {
          this.$message({
            message: "该商品类别已经存在父类别、子类别或该类别下的商品",
            type: 'info'
          })
        }
      },
      clearDate() {
        this.dazhevisible = false
        this.manjianvisible = false
        this.processVisible = false;
        this.distributionVisible = false;
      },
      clearCouponrule() {
        this.couponrule.full = ''
        this.couponrule.minus = ''
        this.couponrule.discount = ''
        this.couponrule.saleprice = ''
        this.couponrule.money = ''
        this.couponrule.maxbuycount = ''
        this.couponrule.categorycode = ""
        this.couponrule.categoryname = ""
        this.couponrule.filltemplate = {}
        this.excludespecial = true;
      },

      clearCustomerName() {
        this.form.customerserial = "";
        this.form.customername = "";
        this.customername = "";
      },
      selectExternalDept(customerserial, deptname, row) {
        this.form.customerserial = customerserial;
        this.form.customername = deptname;
        this.customername = deptname;
        this.getCustomPrice();
      },
      deletequery(index, row) {
        this.formp.splice(index, 1)
      },
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
      },
      onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
      },
      onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.form.county = data.value;
      },
      checkCategory(guids, names, arr) {
        this.$set(this.couponrule, "categorycode", guids)
        this.$set(this.couponrule, "categoryname", names)
      },
      bindDataCategory() {
        this.$refs.treeCategory.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true})
        })
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({})
        })
      },
      initPara(parameterData){
        this.parameterData=parameterData;
      },
      show(type,cusguid) {
        if (type && cusguid) {
          this.initForm();
          this.couponrule.type=type;
          this.form.customerserial=cusguid;
          this.form.customername='购买现金券享受的折扣';
        }
        this.dialogFormVisible = true;
      },
      saveData() {
        this.loading = true;
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.form.independentserial='noshow'

            this.couponrule.excludespecial = this.excludespecial;
            if (this.couponrule.type == '60') {
              var text = JSON.stringify(this.formp);
              for (var i = 0; i < this.formp.length; i++) {
                var num = this.formp[i].discount;
                var fixmoney = this.formp[i].fixmoney;

                if (this.formp[i].dismethod == '1' && (fixmoney === null || fixmoney === undefined || fixmoney === '')) {
                  //注意：不能写 fixmoney == '' —— JS中 0=='' 为true，优惠到0(固定单价0)是允许的
                  this.$message({message: '请输入固定单价', type: 'warning'});
                  this.loading = false
                  return;
                } else if (this.formp[i].dismethod == '2' && (fixmoney === null || fixmoney === undefined || fixmoney === '')) {
                  this.$message({message: '请输入浮动价', type: 'warning'});
                  this.loading = false
                  return;
                } else if (this.formp[i].dismethod == '0' && (num === null || num === undefined || num === '')) {
                  this.$message({message: '请输入折扣价', type: 'warning'});
                  this.loading = false
                  return;
                }
              }
              this.form.salefavouedetail = text;
            }


            let begindate = new Date(this.form.begindate).getTime()
            let enddate = new Date(this.form.enddate).getTime()
            if (begindate > enddate) {
              this.$message({
                message: '开始日期不能大于结束日期',
                type: 'warning'
              });
              this.loading = false
              return;
            }

            if (this.couponrule.type == '10' || this.couponrule.type == '20' || this.couponrule.type == '70') {
              this.form.salefavouedetail = JSON.stringify(this.tableData.concat(this.tableDataSkim));
            }
            if (this.couponrule.type == '50') {
              let tempobj = {}
              this.filltemplate.forEach(o => {
                tempobj[o["value"]] = o["discount"]
              })
              this.$set(this.couponrule, "filltemplate", tempobj)
            } else {
              delete this.couponrule.filltemplate
              delete this.couponrule.categorycode
              delete this.couponrule.categoryname
            }


            this.form.couponrule = JSON.stringify(this.couponrule);

            this.form.externaldeptDO = {}
            saveData(this.form).then(response => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.dialogFormVisible = false;
              //刷新列表
              this.$emit('bindGrid',this.form.customerserial);
            });
          } else {
            this.loading = false
          }
        })
      },

      initData(unitguid) {
        this.initForm();
        getDetail({unitguid: unitguid}).then(response => {
          this.formp = response.data.obj.saleList;

          this.form = response.data.obj;
          if (response.data.obj.externaldeptDO !== null) {
            this.form.customername = response.data.obj.externaldeptDO.deptname
            this.customername = response.data.obj.externaldeptDO.deptname
          }
          if (this.form.couponrule) {
            this.couponrule = JSON.parse(this.form.couponrule);
            this.excludespecial = this.couponrule.excludespecial;
            if ('50' == this.couponrule.type) {
              this.filltemplate = []
              if (this.couponrule.filltemplate) {
                for (let i in this.couponrule.filltemplate) {
                  if (i == '10')
                    this.filltemplate.push({name: "现片", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '20')
                    this.filltemplate.push({name: "定制片", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '30')
                    this.filltemplate.push({name: "区分左右眼", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '80')
                    this.filltemplate.push({name: "镜架", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '40')
                    this.filltemplate.push({name: "数量选择", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '50')
                    this.filltemplate.push({name: "加工", value: i, discount: this.couponrule.filltemplate[i]})
                  else if (i == '60')
                    this.filltemplate.push({name: "特殊加工", value: i, discount: this.couponrule.filltemplate[i]})
                }
              }

            } else if ('60' == this.couponrule.type) {//按商品折扣
              this.getCustomPrice();
            }

          }
        })
      },

      initForm() {
        this.costprice = ''
        this.loading = false;
        this.filltemplate = [{name: "现片", value: '10', discount: ""},
          {name: "定制片",value: '20',discount: ""},
          {name: "区分左右眼", value: '30', discount: ""},
          {name: "镜架", value: '80', discount: ""},
          {name: "数量选择", value: '40', discount: ""},
          {name: "加工",value: '50',discount: ""},
          {name: "特殊加工", value: '60', discount: ""}]
        this.dazhevisible = false
        this.manjianvisible = false
        this.couponrule = {type: '', full: '', minus: '', discount: '', saleprice: '', money: '', maxbuycount: ''}
        // this.query = [{"full": "", "give": ""}],
        this.tableData = []
        this.tableDataSkim = []
        this.formp = [];
        this.form = {};
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        if (this.$refs.treeSeed != undefined) {
          this.$refs.treeSeed.reset();
        }
        if (this.$refs.treeCategory != undefined) {
          this.$refs.treeCategory.reset();
        }
        this.form.customername = '';
        this.customername = "";
        if (this.forExternalDept)
          this.couponrule.type = '50';
      },
    },
    mounted() {
    },
    components: {
      JxcgooddetailSel,
      JxcgoodscategorySel,
    },
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .center {
    text-align: center;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/salefavour/SaleFavourCopy.vue